import { regex } from '../../../common/regex.constants';

export class CustomerModel {
  /**
   *@var customer to store the customer value email or phone
   **/
  private customer: string;
  /**
   *@var error to store error status
   **/
  public error: boolean;
  /**
   *@var mode to store mode (read or edit)
   **/
  public mode: string;
  constructor(customer: string) {
    this.customer = customer ? customer : emptyCustomer;
  }
  /**
   * placeholder returns the placeholder
   **/
  get placeholders(): string {
    return 'customer-search.input-placeholder';
  }
  /**
   * apiCall returns if the model needs an api call  or not
   **/
  get apiCall(): boolean {
    return false;
  }
  /**
   * title returns if the title of the search bar
   **/
  get title(): string {
    return 'customer-search.title';
  }
  /**
   * setMode sets the mode edit or read
   **/
  public set setMode(mode: string) {
    this.mode = mode;
  }
  /**
   * getRouteParams Returns the routing parameters for redirection
   **/
  get getRouteParams(): object {
    return this.mode === 'read' ? Object.assign(
      regex.phoneNumberPattern.test(this.customer) ||
        regex.phonePatternWithChar.test(this.customer) || regex.phonePatterWithCountryCode.test(this.customer) ?
        { phone: this.customer.replace(/\D/g, '') } : { email: this.customer },
      { mode: 'read' }) : { mode: 'edit' };
  }
  /**
   * getVinlistParams Returns the params for vin list by guid
   **/
  get getVinlistParams(): object {
    return {};
  }

}

/**
 * emptyCustomer empty customer data for initial display
 */
export const emptyCustomer: any = {
  customerType: '',
  firstName: '',
  guid: '',
  objectId: '',
  lastName: '',
  preferredLanguage: '',
  createSource: '',
  lastUpdateSource: '',
  lastUpdateDate: '',
  createDate: '',
  phoneNumbers: [
    {
      countryCode: 1,
      phoneVerified: false,
      phoneNumber: '',
      phoneType: '',
    }
  ],
  emails: [
    {
      emailAddress: '',
      emailType: '',
      emailVerified: false
    }
  ],
  uiLanguage: '',
  smsConsent: ''
};
